import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  loadSector,
  loadSeats,
  createSector,
  createSeats
} from '~/state/modules/planimetry'
import { PaperContainer } from '~/views/shared'
import { SectorForm } from '../SectorForm'
import { ROUTES } from '~/views/routes'
import history from '~/config/history'
import { PositionDescriptor, SEATS_STATUS } from 'config/constants'
import { cloneSeatsGrid } from '../SeatsDistribution/SeatSettings/lib/utils'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'
import { cleanHexColor } from 'views/utils/functions'

export const SectorClonePage = ({ match, onSuccess }) => {
  const { pendingCreateLayout, pendingCreateSeats, sector, seats } =
    useSelector((state) => state.planimetry)
  const { locationId, layoutId, sectorId } = match.params

  const dispatch = useDispatch()

  useEffect(() => {
    async function fetchData() {
      await dispatch(loadSector(sectorId))
      await dispatch(loadSeats(sectorId))
    }

    fetchData()
    // eslint-disable-next-line
  }, [match])

  const createSeatsPayload = (newSectorId, seats, newRows, newColumns) => {
    const updatedSeats = cloneSeatsGrid(newRows, newColumns, seats).map(
      (seat) => ({
        Column: seat.column,
        Row: seat.row,
        IsSeat: true,
        Status: SEATS_STATUS[seat.status],
        Id: seat.id || null
      })
    )
    return {
      SectorId: newSectorId,
      Column: newColumns,
      Row: newRows,
      Seats: updatedSeats
    }
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true)
      const sector = await dispatch(createSector(values))
      const payload = createSeatsPayload(
        sector.Id,
        seats,
        values.Row,
        values.Column
      )
      await dispatch(createSeats(payload))
      onSuccess(locationId, layoutId)
      showSnackbarSuccess('Sector Creado!')
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setSubmitting(false)
    }
  }

  const values = {
    SectorName: sector?.Name || '',
    Column: sector?.Column || '',
    ColumnDescriptor: sector?.ColumnDescriptor || PositionDescriptor.Numeric,
    Row: sector?.Row || '',
    RowDescriptor: sector?.RowDescriptor || PositionDescriptor.Numeric,
    ImageId: sector?.ImageId || '',
    ImageFile: sector?.ImageCdnUrl || null,
    LayoutId: layoutId,
    Color: cleanHexColor(sector?.Color)
  }

  return (
    <PaperContainer title='Clonación de Sector'>
      <SectorForm
        values={values}
        actionText='Crear'
        handleSubmit={handleSubmit}
        actionPending={pendingCreateLayout || pendingCreateSeats}
        onCancel={() =>
          history.push(
            ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.INDEX.replace(
              ':locationId',
              locationId
            ).replace(':layoutId', layoutId)
          )
        }
      />
    </PaperContainer>
  )
}

export default SectorClonePage
